export const STUDENT_BOOK_ADDITION = 'STUDENT_BOOK_ADDITION'



// WEBPACK FOOTER //
// ./src/store/Admin/modules/studentBookAddition/types.js